import {
  SET_USER_DATA,
  SET_ADDRESS,
  SET_CARTS,
  SET_USER_DATALAYER_SENT,
} from "../types"

export const setUserData = (payload) => (dispatch) => {
  if (!payload) {
    dispatch({ type: SET_ADDRESS, payload: null })
    dispatch({ type: SET_CARTS, payload: null })
    dispatch({
      type: SET_USER_DATA,
      payload: null,
    })
  } else {
    if (payload.addresses.length > 0)
      dispatch({ type: SET_ADDRESS, payload: payload.addresses })
    if (payload.carts?.items.length > 0)
      dispatch({ type: SET_CARTS, payload: payload.carts })
    dispatch({
      type: SET_USER_DATA,
      payload: payload.me,
    })
  }
}

export const setUserDatalayerSent = (userId) => ({
  type: SET_USER_DATALAYER_SENT,
  payload: userId,
})
